export enum ConsentKeys {
  EMAIL_MARKETING = 'emailMarketing',
  TARGETED_ADVERTISING = 'targetedAdvertising',
}

export const UPDATE_CONSENT_CHANNEL = 'web-account'
